import {
  RevokeInvitationModalProps as _RevokeInvitationModalProps,
  RevokeInvitationModalDataProps,
} from "./revoke-invitation-modal-view";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../../util/typeUtil";
import { ActionSender } from "../../../model/ActionSender";
import { AppState } from "../../../store/AppState";
import InProgressUtils from "../../../utils/in-progress";
import OrganizationUtils from "../../../utils/organization";
import { addSenderArgument } from "../../../actions/actionHelpers";
import {
  clearError,
  getOrganizationsOrganizationGroupInvitation,
  revokeOrganizationGroupInvitation,
} from "../../../actions";
import { connect } from "react-redux";
import RevokeInvitationModal from "./revoke-invitation-modal-container";

export interface RevokeInvitationModalProps
  extends Omit<
    _RevokeInvitationModalProps,
    keyof RevokeInvitationModalDataProps
  > {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _RevokeInvitationModalProps,
  RevokeInvitationModalProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _RevokeInvitationModalProps,
  RevokeInvitationModalProps
>;
const sender: ActionSender = { key: "revoke-invitation" };

function mapStateToProps(
  state: AppState,
  ownProps: RevokeInvitationModalProps
): ReduxStateProps {
  return {
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
    invitation: ownProps.invitationId
      ? OrganizationUtils.selectOrganizationInvitation(
          ownProps.invitationId,
          state
        )
      : undefined,
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    OrganizationUtils.compareOrganizationInvitationsStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onRevokeInvitation: addSenderArgument(
    sender,
    revokeOrganizationGroupInvitation
  ),
  onLoadInvitation: addSenderArgument(
    sender,
    getOrganizationsOrganizationGroupInvitation
  ),
  onClearError: clearError,
};
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  RevokeInvitationModalProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual,
})(RevokeInvitationModal);
